import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';
import { palette } from 'themeV5/palette';

const muiTooltip: {
  defaultProps?: ComponentsProps['MuiTooltip'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
  variants?: ComponentsVariants['MuiTooltip'];
} = {
  styleOverrides: {
    tooltip: {
      backgroundColor: palette.background.paper,
      borderColor: palette.gray[500],
      fontSize: 14,
      color: palette.text.primary,
      boxShadow: '2px 2px 10px -3px rgba(0,0,0,0.71)',
    },
  },
};

export default muiTooltip;
